import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import SetPasswordCard from "../../components/auth/SetPasswordCard";
import { validateResetTokenAPI } from "../../API/endpoints/auth";
import classes from "../../components/auth/RegistrationStatus.module.scss";

export default function ResetPassword() {
  const [isLoading, setIsLoading] = useState(true);
  const [isLinkValid, setIsLinkValid] = useState();

  const [searchParams] = useSearchParams();
  const confirmToken = searchParams.get("token");

  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await validateResetTokenAPI(confirmToken);
        if (response.status === 204) setIsLinkValid(true);
      } catch {
        setIsLinkValid(false);
      } finally {
        setIsLoading(false);
      }
    };
    validateToken();
  }, [confirmToken]);

  return (
    <div>
      {isLoading ? (
        <p>Loading...</p>
      ) : isLinkValid ? (
        <SetPasswordCard title="Reset password" reset />
      ) : (
        <div className={classes.container}>
          <div className={classes.message}>This link is expired</div>
        </div>
      )}
    </div>
  );
}
